import { NgModule } from '@angular/core';
import { ConfirmationModalComponent } from '@app/core/components/modal/confirmation-modal/confirmation-modal.component';
import { ConfirmationModalWithReasonComponent } from '@app/core/components/modal/confirmation-modal-with-reason/confirmation-modal-with-reason.component';
import { SharedModule } from '@app/shared/shared.module';

@NgModule({
  imports: [
    SharedModule
  ],
  declarations: [
    ConfirmationModalComponent,
    ConfirmationModalWithReasonComponent
  ],
  exports: [
    ConfirmationModalComponent,
    ConfirmationModalWithReasonComponent
  ]
})
export class ModalModule {

}
